import * as React from "react";
import MainListItems from "../LisHeaderProvaider/listItems";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./Header.css";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../../Redux/User/UserAction";
import { useMsal } from "@azure/msal-react";
function Header(props: any) {
  const { menu, setIsOpen, open } = props;
  const dispatch = useDispatch();
  const handleOpenClose = () => {
    setIsOpen(!open);
  };
  const user = useSelector((state: any) => state.userReducer.user);
  const position = useSelector((state: any) => state.userReducer.position);
  const { instance, accounts } = useMsal();
  // Si no hay foto o no carga, Avatar muestra el icono de usuario
  const userImg = user?.employee?.url_img
    ? process.env.REACT_APP_API_BACKEND + "/" + user.employee.url_img
    : undefined;
  const handleLogOut = () => {
    localStorage.removeItem("aedas_user");
    dispatch(userLogout());
    instance.logoutRedirect({
      account: accounts[0],
    });
  };

  return (
    <div
      className="sideMenu"
      style={{
        width: open ? "300px" : "70px",
        zIndex:10,
        height: "100%",
        backgroundColor: "var(--aedas-white)",
        position: "fixed",
        overflow: "hidden",
        boxShadow: "rgb(216 216 216 / 40%) 1px 1px 10px"
      }}
    >
      <div className="d-flex justify-content-center w-100">
        <img
          src="/Assets/img/LogoAedasSmall.svg"
          alt="AEDAS Homes"
          style={{ height: "70px" }}
        ></img>
        {open ? (
          <div className="d-flex align-items-center">
            <h1 className="appName">Inventario</h1>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="openCloseButton_container">
        <IconButton onClick={handleOpenClose} className="openCloseButton">
          {open ? (
            <ArrowBackIosIcon></ArrowBackIosIcon>
          ) : (
            <ArrowForwardIosIcon></ArrowForwardIosIcon>
          )}
        </IconButton>
      </div>

      <MainListItems
        setOpen={setIsOpen}
        open={open}
        menu={menu}
      ></MainListItems>
      {open ? (
        <div className="personHeader">
          <hr style={{ margin: "20px" }}></hr>

          <div className="p-2 w-100 d-flex justify-content-between">
            <div className="d-flex justify-content-center">
              <Avatar
                className="userAvatar"
                src={userImg}
                alt={user?.employee?.display_name}
                sx={{ width: 48, height: 48, bgcolor: "var(--aedas-lightgrey)" }}
              >
                <PersonIcon sx={{ fontSize: 32 }} />
              </Avatar>
            </div>
            <div className="d-flex align-items-center">
              <div>
                <h1 className="userName">
                  {user?.employee?.display_name}
                </h1>
                <h2 className="detail-text userPosition">
                  {position}
                </h2>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center">
                <IconButton
                  onClick={() => {
                    handleLogOut();
                  }}
                >
                  <PowerSettingsNewIcon></PowerSettingsNewIcon>
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="personHeader ">
          <div className="p-2 w-100">
            <div className="d-flex justify-content-center">
              <Avatar
                className="userAvatar"
                src={userImg}
                alt={user?.employee?.display_name}
                sx={{ width: 36, height: 36, bgcolor: "var(--aedas-lightgrey)" }}
              >
                <PersonIcon sx={{ fontSize: 24 }} />
              </Avatar>
            </div>

            <div>
              <div className="d-flex justify-content-center">
                <IconButton
                  onClick={() => {
                    handleLogOut();
                  }}
                >
                  <PowerSettingsNewIcon></PowerSettingsNewIcon>
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
